<template>
  <v-container class="pa-0">
    <v-row class="ma-0 pb-3">
      <h3 class="text-h5 grey--text text--darken-1 pa-0">
        {{ $t("signup.lbl.terms") }}
      </h3>
    </v-row>
    <ValidationObserver ref="form">
      <!-- 약관 로우(컴포넌트화해도 좋을듯?) -->
      <v-row v-for="(item, index) in termsStep" :key="index">
        <!-- 약관그룹 4컬럼 -->
        <v-col cols="12" sm="4" class="pb-0 pb-sm-3">
          <p class="text-h6 grey--text text--darken-3 pa-0 ma-0">
            {{ item.termsCodeName }}
          </p>
        </v-col>
        <!-- 약관 내용 8컬럼 -->
        <v-col cols="12" sm="8" class="pt-0 pt-sm-3">
          <!-- 약관 항목 1번 12컬럼 -->
          <v-col cols="12" class="align-center d-flex pa-0 pb-4 pb-sm-2">
            <rx-check-box
              v-model="item.agreed"
              :rules="
                item.required ? { required: item.agreed ? true : null } : null
              "
              @change="changeAgree"
              :label="
                item.required
                  ? $t('signup.lbl.agree_terms_required')
                  : $t('signup.lbl.agree_terms_select')
              "
              :name="item.termsCodeName"
              append
              innerClass="ma-0 pa-0"
              hide-details="auto"
            >
            </rx-check-box>

            <v-btn
              class="d-inline"
              tile
              depressed
              icon
              @click="openDialog(item)"
              color="primary"
              rounded
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-col>
        </v-col>
      </v-row>
    </ValidationObserver>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="0" sm="4" class="pa-0"></v-col>
      <v-col cols="12" sm="8" class="py-8 py-sm-4">
        <v-checkbox
          v-model="allAgree"
          @change="syncAllAgree"
          :label="$t('signup.lbl.agree_all')"
          class="ma-0"
          hide-details="auto"
        ></v-checkbox>
      </v-col>
    </v-row>

    <!-- 약관 다이얼로그 -->
    <v-dialog
      v-model="termsDialog"
      max-width="1024px"
      :fullscreen="$vuetify.breakpoint.mdAndUp ? false : true"
      v-if="termsDialog"
      transition="dialog-bottom-transition"
    >
      <rc-terms-detail
        :termsCode="selectedTerms.termsCode"
        @closeDialog="closeDialog"
        :isOpenDialog="true"
        @agreeTerms="agreeTerms"
      ></rc-terms-detail>
    </v-dialog>
  </v-container>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import RcTermsDetail from "@/redcrm/components/terms/RcTermsDetail.vue";

export default {
  components: {
    ValidationObserver,
    RcTermsDetail,
  },
  props: {
    termsStep: null,
    termsList: null,
  },

  data() {
    return {
      termsDialog: false,
      isOpenDialog: false,
      innerCheckbox: false,
      allAgree: false,
      agreed: false,
      selectedTerms: {},
      activeTerms: [],
      dialog: null,
    };
  },
  methods: {
    closeDialog() {
      //다이얼로그 안 체크박스와 밖의 다이얼로그 상태 동기화
      this.selectedTerms = null;
      this.termsDialog = false;
    },
    agreeTerms() {
      this.selectedTerms.agreed = true;
      this.termsDialog = false;
      this.changeAgree();
    },
    openDialog(terms) {
      this.selectedTerms = terms;
      this.termsDialog = true;
    },
    syncAllAgree() {
      this.termsStep.forEach((element) => (element.agreed = this.allAgree));
    },

    async validate() {
      this.$refs.form.reset();
      return await this.$refs.form.validate();
    },
    getTermsValue() {
      return this.termsStep;
    },
    changeAgree() {
      this.$nextTick(() => {
        if (
          this.termsStep.length ==
          this.termsStep.filter((x) => x.agreed == true).length
        ) {
          this.allAgree = true;
        } else {
          this.allAgree = false;
        }
      });
    },
  },
  mounted() {},
  watch: {
    termsStep(v) {
      this.activeTerms = v;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-dialog {
  overflow-y: inherit !important;
}

iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.cardArea {
  height: calc(100% - 68px - 92px);
}
</style>
